import { render, staticRenderFns } from "./LandlordRequest.vue?vue&type=template&id=492ca41d&scoped=true&"
import script from "./LandlordRequest.vue?vue&type=script&lang=js&"
export * from "./LandlordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ca41d",
  null
  
)

export default component.exports